import React, { useEffect, useState } from "react";
import AppGridContainer from "@crema/core/AppGridContainer";
import Grid from "@mui/material/Grid";
import SlideBasicFour from "components/carousel/carouselWithDescription";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LatestNews from "components/latestNews";
import InfoWidget from "components/InfoWidget";
import DateSelector from "components/EventPicker";
import { blue, green, orange, red } from "@mui/material/colors";
import { Box } from "@mui/material";
import { Fonts } from "shared/constants/AppEnums";
import UpcomingBirthdays from "components/UpcomingBirthdays";
import QuickLinkCard from "components/QuickLinks";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getNewsAndUpdate, getUserBirthDay } from "redux/actions/Home";
import { useAuthUser } from "@crema/utility/AuthHooks";
import { RoutePermittedRole } from "shared/constants/AppConst";
export default function Home() {
    const dispatch = useDispatch();
    const { user } = useAuthUser();
    const userBdayList = useSelector((state) => state.homeReducer.userBdayList);
    const newsAndUpdateList = useSelector(
        (state) => state.homeReducer.newsAndUpdateList
    );

    const [infoWidgets, setInfoWidgets] = useState([]);
    useEffect(() => {
        dispatch(getUserBirthDay());
        dispatch(getNewsAndUpdate());
    }, []);

    useEffect(() => {
        let widgetsData = [
            {
                id: 1,
                icon: "/assets/images/dashboard/attendance.svg",
                color: "#b7d9f7",
                bgColor: "#FFF",
                title: "Attendance",
                url:
                    user.role === RoutePermittedRole.SUPER_ADMIN ||
                    user.role === RoutePermittedRole.ADMIN ||
                    user.role === RoutePermittedRole.HR_MANAGER
                        ? "/attendance"
                        : user.role === RoutePermittedRole.LOCATION_MANAGER
                        ? "/present"
                        : "/my-attendance",
            },
            {
                id: 2,
                icon: "/assets/images/dashboard/stay-request.svg",
                color: "#fce3b8",
                bgColor: "#FFF",
                title: "Stay Request",
                url:
                    user.role === RoutePermittedRole.SUPER_ADMIN ||
                    user.role === RoutePermittedRole.ADMIN ||
                    user.role === RoutePermittedRole.LOCATION_MANAGER ||
                    user.role === RoutePermittedRole.FRONTDESK ||
                    user.role === RoutePermittedRole.KITCHEN ||
                    user.role === RoutePermittedRole.ACCOMODATION ||
                    user.role === RoutePermittedRole.SETUP_MANAGER
                        ? "/room/logs"
                        : "/room/booking-request",
            },

            {
                id: 3,
                icon: "/assets/images/dashboard/leave-travel-request.svg",
                color: "#bccbd2",
                bgColor: "#FFF",
                title: "Leave/Travel Request",
                url:
                    user.role === RoutePermittedRole.MEMBER
                        ? "/leave/requests"
                        : user.role === RoutePermittedRole.FRONTDESK ||
                          user.role === RoutePermittedRole.KITCHEN ||
                          user.role === RoutePermittedRole.ACCOMODATION
                        ? "/leave/approved"
                        : "/leave/logs",
            },
            {
                id: 4,
                icon: "/assets/images/dashboard/raise-issues.svg",
                color: "#b7e8cb",
                bgColor: "#FFF",
                title: "Issue Resolution Request",
                url:
                    user.role === RoutePermittedRole.SUPER_ADMIN
                        ? "/issue/category"
                        : user.role === RoutePermittedRole.ADMIN ||
                          user.role === RoutePermittedRole.SETUP_MANAGER
                        ? "/issue/logs"
                        : user.role === RoutePermittedRole.LOCATION_MANAGER
                        ? "/issue/approval"
                        : "/issue/list",
            },
            {
                id: 5,
                icon: "/assets/images/dashboard/feedback.svg",
                color: "#b7e8cb",
                bgColor: "#FFF",
                title: "Feedback",
                url:
                    user.role === RoutePermittedRole.SUPER_ADMIN
                        ? "/feedback"
                        : user.role === RoutePermittedRole.ADMIN
                        ? "/feedback-response"
                        : "/dashboard",
            },
            {
                id: 6,
                icon: "/assets/images/dashboard/crm.svg",
                color: "#fce3b8",
                bgColor: "#FFFF",
                title: "Satsangee Management",
                url: "/crm/client-list",
            },

            {
                id: 7,
                icon: "/assets/images/dashboard/performance.svg",
                color: "#fce3b8",
                bgColor: "#FFF",
                title: "Performance",
                url: "/performance/goal",
            },
            {
                id: 8,
                icon: "/assets/images/dashboard/satsangee-base.svg",
                color: "#b7d9f7",
                bgColor: "#FFF",
                title: "Satsangee Base",
                url: "",
            },
        ];
        setInfoWidgets(widgetsData);
    }, []);

    return (
        <>
            <AppGridContainer>
                <Grid item xs={12} md={8}>
                    <SlideBasicFour data={newsAndUpdateList.slice(0, 5)} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <LatestNews data={newsAndUpdateList.slice(5, 8)} />
                </Grid>

                <Grid item xs={12} md={8}>
                    <AppGridContainer>
                        {infoWidgets.map((data, index) => (
                            <Grid
                                item
                                xs={6}
                                sm={4}
                                md={3}
                                key={"grid-" + index}
                            >
                                <InfoWidget data={data} />
                            </Grid>
                        ))}
                    </AppGridContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                    <DateSelector />
                </Grid>

                <Grid item xs={12} md={8}>
                    <Box
                        component="h2"
                        sx={{
                            color: "text.primary",
                            bgColor: "#FFF",
                            mb: { xs: 4, sm: 4, xl: 6 },
                            fontSize: 16,
                            fontWeight: Fonts.SEMI_BOLD,
                        }}
                    >
                        Quick Links
                    </Box>

                    <AppGridContainer>
                        <Grid item xs={6} sm={6} md={3}>
                            <QuickLinkCard
                                href="/policies"
                                text={"Policies"}
                                bgColor={blue[500]}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                            <QuickLinkCard
                                href="/manuals"
                                text={"Manuals"}
                                bgColor={red[500]}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                            <QuickLinkCard
                                text={"Reports"}
                                bgColor={green[500]}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3}>
                            <QuickLinkCard
                                href="/my-profile"
                                text={"Settings"}
                                bgColor={orange[500]}
                            />
                        </Grid>
                    </AppGridContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                    <UpcomingBirthdays data={userBdayList} />
                </Grid>
            </AppGridContainer>
        </>
    );
}
